import { SubmitStatus } from '../types/submitSequence';

// common subset of props from validation reports from multiple services
interface CommonValidationError {
  message?: string | null;
}

interface CommonValidationResult {
  errors?: CommonValidationError[] | null | undefined;
}

interface CommonValidationReport {
  isValid?: boolean;
  results?: { result?: CommonValidationResult | null }[] | null;
}

export const extractMessagesFromValidationReport = (
  report: CommonValidationReport
): string[] | undefined => {
  return report?.results
    ?.flatMap((i) => i.result?.errors?.map((x) => x.message) || [])
    .filter((x): x is string => !!x);
};

export const processPrevalidationReport = <T extends CommonValidationReport>(
  res: T
): SubmitStatus<T> => {
  if (res.isValid) {
    return {
      success: true,
      result: res,
    };
  }
  return {
    success: false,
    errors: extractMessagesFromValidationReport(res) || [],
  };
};
